import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M20.94 6.826c-.011-.576-.022-1.12-.022-1.646a.747.747 0 0 0-.746-.747c-3.194 0-5.625-.918-7.652-2.888a.746.746 0 0 0-1.04 0c-2.027 1.97-4.458 2.888-7.652 2.888a.747.747 0 0 0-.746.747c0 .526-.01 1.07-.022 1.647-.102 5.36-.242 12.7 8.695 15.798a.75.75 0 0 0 .49 0c8.937-3.098 8.797-10.439 8.695-15.799Z"
    />
    <path
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.606 10.394V7h-3.211v3.394H7v3.212h3.395V17h3.211v-3.394H17v-3.212z"
    />
  </svg>
);
export const HealthInsuranceIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
